var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Dropdown',{directives:[{name:"show",rawName:"v-show",value:(_vm.showUserDropdown),expression:"showUserDropdown"}],attrs:{"is-open":_vm.showUserDropdown},on:{"close-dropdown":_vm.close}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }